import { render, staticRenderFns } from "./courseList_new.vue?vue&type=template&id=07d56d0f&scoped=true"
import script from "./courseList_new.vue?vue&type=script&lang=js"
export * from "./courseList_new.vue?vue&type=script&lang=js"
import style0 from "./courseList_new.vue?vue&type=style&index=0&id=07d56d0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d56d0f",
  null
  
)

export default component.exports